import React from 'react'
import { IconSVGType } from '../../../types/icons'

export const VisaCardWhiteIcon = (props: IconSVGType) => {
  return (
    <svg
      width='43'
      height='14'
      viewBox='0 0 43 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.2418 4.4787C22.2203 6.43067 23.9618 7.5151 25.284 8.16576C26.6385 8.82726 27.09 9.26104 27.09 9.84663C27.0793 10.7576 26.015 11.1588 25.0045 11.1696C23.263 11.2022 22.2418 10.6925 21.4355 10.3129L20.812 13.2843C21.6183 13.6638 23.1233 13.9892 24.6712 14C28.3155 14 30.7128 12.1782 30.7235 9.36948C30.7343 5.79086 25.8215 5.59566 25.8538 4.00155C25.8645 3.51356 26.3267 3.00387 27.3265 2.87374C27.821 2.80868 29.197 2.75445 30.7558 3.48102L31.3685 0.607281C30.5193 0.292796 29.4443 0 28.1113 0C24.6713 0 22.2633 1.84353 22.2418 4.4787ZM37.2272 0.249419C36.5607 0.249419 36.0018 0.639814 35.7438 1.2471L30.53 13.8048H34.185L34.916 11.7769H39.3772L39.7965 13.8048H43L40.1943 0.249419H37.2272ZM37.7433 3.90395L38.7967 8.98993H35.905L37.7433 3.90395ZM17.8127 0.249419L14.9425 13.794H18.4148L21.2958 0.249419H17.8127ZM12.6743 0.249419L9.06225 9.46708L7.60025 1.62665C7.42825 0.748257 6.751 0.249419 5.9985 0.249419H0.086L0 0.639814C1.21475 0.900077 2.59075 1.33385 3.42925 1.78931C3.94525 2.07126 4.085 2.30984 4.257 2.98218L7.0305 13.794H10.707L16.3293 0.249419H12.6743Z'
        fill='white'
      />
    </svg>
  )
}
